import type { ReactNode } from 'react';

import styles from './BehavioralAlertsEntry.module.sass';

export { CategoriesValue } from './CategoriesValue';

interface BehavioralAlertsEntryProps {
  label: string;
  value: ReactNode | string;
}

export const BehavioralAlertsEntry = ({
  label,
  value,
}: BehavioralAlertsEntryProps) => {
  return (
    <div className={styles.entry}>
      <div className={styles.label}>{label}</div>
      <div className={styles.dots} />
      <div className={styles.value}>{value}</div>
    </div>
  );
};
